<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas por Produtos do Período {{data_inicio_cabecalho }} á {{data_fim_cabecalho }}</h4>
          </div>

          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <select v-if="moduloVendedores" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="vendedor_cabecalho">
              <option value="">Selecione um vendedor...</option>
              <option v-for="vendedor of vendedores" :value="vendedor.codigo">{{ vendedor.nome }}</option>
            </select>
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>
          <div class="mb-3">
            <div v-for="venda of vendas" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-7">
                <strong>{{ venda.nome }}</strong>
                <br>
                Código: {{ venda.codigo }}
                <br>
                <span style="color: #888; font-size: 10px;">{{ venda.data | moment("DD/MM/YYYY") }} {{ venda.hora }}</span>
              </div>
              <div class="col-5">
                Qtd: {{ venda.vendas }}
                <br>
                {{ venda.faturado | currencyBrl(true) }}
              </div>
            </div>

            <div class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-7">
                <strong>Custo:</strong>
                <br>
                <strong>Faturado:</strong>
              </div>
              <div class="col-5">
                <strong>{{ total.custo | currencyBrl(true) }}</strong>
                <br>
                <strong>{{ total.faturado | currencyBrl(true) }}</strong>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <template v-if="vendedor">
                Mostrando vendas do(a): {{ vendedor_nome }}
              </template> 
            </div>
            <div class="col-md-6" align="right">
              <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary" @click="exportaPDF">Exportar PDF</button>
              <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary" @click="exportaExcel">Exportar Excel</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <input class="pull-right form-control" placeholder="Pesquisar..." v-debounce:350ms="search" v-model="query" style="max-width: 250px; margin-right:0;">
            </div>
          </div>
          <table id="myTable" class="display responsive nowrap table table-hover table-striped hidden-mobile">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nome</th>
                <th>Quantidade</th>
                <th>Custo</th>
                <th>Faturado</th>
                <th v-if="vendedor">Comissão {{ vendedor_comissao }}</th>
                <th>CMV</th>
              </tr>
            </thead>
            <tbody>
              <tr id="tr" v-for="venda of vendas">
                <td>{{ venda.referencia }}</td>
                <td>{{ venda.nome }}</td>
                <td>{{ venda.vendas }}</td>
                <td>{{ venda.custo | currencyBrl(true)}}</td>
                <td>{{ venda.faturado | currencyBrl(true)}}</td>
                <td v-if="vendedor">{{ venda.comissao | currencyBrl(true)}}</td>
                <td></td>
              </tr>
              <tr v-if="!vendas">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td></td>
                <td>{{ total.qtd }}</td>
                <td>{{ total.custo | currencyBrl(true) }}</td>
                <td>{{ total.faturado | currencyBrl(true) }}</td>
                <td v-if="vendedor">{{ total.comissao | currencyBrl(true) }}</td>
                <td>{{ cmv | currencyBrl(false) }}%</td>
              </tr>              
            </tfoot> 
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import { EventBus } from '@/services/EventBus'
import moment from 'moment'
import jQuery from 'jquery'
import VendaService from '@/services/VendaService.js'
import VendedorService from '@/services/VendedorService.js'
export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_inicio_cabecalho: moment().format("DD/MM/YYYY"),
        data_fim_cabecalho: moment().format("DD/MM/YYYY"),
        vendas: null,
        current_page: 1,
        pageCount: 0,
        total:0,
        cmv:0,
        vendedor_cabecalho: "",
        vendedor_comissao: "",
        vendedor_nome: "",
        vendedor: "",
        vendedores: "",
        query: "",  
        moduloVendedores: localStorage.getItem('config_modulo_vendedor') == "true" ? true : false,
        last_searched: null,
      }
    },
    methods:{
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },
      loadVendas() {
        let loader = this.$loading.show()
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}&query=${this.query}`;
        
        if(this.vendedor_cabecalho) {
          this.vendedor_comissao = this.vendedores.find(x => x.codigo == this.vendedor_cabecalho).comissao + "%"
          this.vendedor_nome = this.vendedores.find(x => x.codigo == this.vendedor_cabecalho).nome
          this.vendedor = this.vendedor_cabecalho
          params += `&vendedor=${this.vendedor}`
        } else {
          this.vendedor = null;
        }

        VendaService.loadPorProduto(params).then(res => {
          this.total = res.data.total;
          delete res.data.total;
          if(this.total.faturado){
            this.cmv = parseFloat((this.total.custo/this.total.faturado)*100)
          }
          this.vendas = res.data;
          loader.hide()
        }).catch(err => {
          loader.hide()
        })
      },
      search(e) {

        if(e != this.last_searched) {
          this.current_page = 1
          this.loadVendas()
          this.last_searched = e;
        }
      },
      exportaPDF(){
    
          VendaService.geraRelatorioProdutoPDF("?data_fim="+this.data_fim+"&data_inicio="+this.data_inicio).then(pdf =>{
            let data = pdf.data;
            
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            let name = "Relatório Por Produto.pdf";
            // url = window.URL.createObjectURL(data);
            a.href = "data:application/pdf;base64,"+data;
            a.target= "_blank";
            a.download = name;
            a.click();
          })

          
      },
      exportaExcel(){
          VendaService.geraRelatorioProdutoExcel("?data_fim="+this.data_fim+"&data_inicio="+this.data_inicio).then(pdf =>{
            let data = pdf.data;            
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            let name = "Relatório Por Produto.xls";
            // url = window.URL.createObjectURL(data);
            a.href = "data:application/vnd.ms-excel;base64,"+data;
            a.target= "_blank";
            a.download = name;
            console.log(data)
            a.click();
          })

          
      },
      changePage(page) {
        this.current_page = page
        this.loadVendas()
      },
      loadVendedores() {
        VendedorService.load().then(res => {
          this.vendedores = res.data
        })
      }
    },
    mounted() {
      this.loadVendas()
      this.loadVendedores()

      EventBus.$on('moduloVendedores', res => {
        console.log("ASD")
        if(res == "true") {
          this.moduloVendedores = true;
        } else {
          this.moduloVendedores = false;
        }
      })
    }
}
</script>